<template>
  <div class="page">
    <div class="page_top">
      <div class="sechout">
        <div class="sech-left" @click="back()">
          <van-icon name="arrow-left" color="#ffffff" size="20" />
        </div>
        <div class="sech-right" @click="toRecord">报修记录</div>
      </div>
      <div class="page_top_title">
        <span class="page_top_title_txt">在线报修</span>
      </div>
    </div>
    <div class="content">
      <van-row type="flex" justify="center">
        <van-col span="22">
          <div>
            <div class="property_info">
              <img class="house_address_icon" src="../../../../assets/house/property/house_address_icon.png" alt="">
              <span class="property_info_txt">阳光城上府1区1幢1单元1011</span>
            </div>
            <div class="sort_title">报修类别</div>
            <div class="sort_content">
              <div v-for="(item,index) in repairList" :key="'repairList_item'+index"
                :class="[type == item.value?'sort_item_active':'sort_item']" @click="type = item.value">{{item.name}}
              </div>
            </div>
            <div class="sort_title">详情描述</div>
            <div class="sort_textbox" @click="describe = '被困电梯三天了，希望能快点把电梯打开'">
              <span v-if="describe == ''" class="sort_textbox_placeholder">请描述下具体的报修信息</span>
              <span v-else class="sort_textbox_txt">{{describe}}</span>
            </div>
            <div v-if="!imgShow" class="upload" @click="imgShow = !imgShow">
              <span class="upload_add">+</span>
            </div>
            <img @click="imgShow = !imgShow" v-else class="propertyIndexTab2"
              src="../../../../assets/house/property/propertyIndexTab2.png" alt="">
            <div class="btn" @click="result">提交</div>
          </div>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        repairList: [{
          name: '电路维修',
          value: 1
        }, {
          name: '水路维修',
          value: 2
        }, {
          name: '房屋维修',
          value: 3
        }, {
          name: '空调维修',
          value: 4
        }, {
          name: '电梯维修',
          value: 5
        }, {
          name: '其他',
          value: 6
        }, ],
        type: '',
        describe: '',
        imgShow: false,
      }
    },
    methods: {
      back() {
        this.$router.go(-1);
      },
      toRecord() {
        this.$router.push('/house/property/propertyRepairRecord')
      },
      result() {
        this.$router.push('/house/property/propertyRepairSuccess')
      }
    }
  }
</script>

<style lang="less" scoped>
  .page_top {
    height: 162px;
    background: #26C165;
  }

  .sechout {
    height: 44px;
    padding: 15px 15px 15px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .sech-left,
  .sech-right {
    font-size: 15px;
    font-weight: 500;
    color: #FFFFFF;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .page_top_title {
    padding-left: 20px;
    margin-top: 14px;
    font-size: 24px;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 24px;
  }

  .content {
    background: #fff;
    padding-top: 20px;
    transform: translateY(-12px);
    border-radius: 12px 12px 0px 0px;
  }

  .property_info {
    display: flex;
    align-items: center;
    padding-bottom: 16px;
    margin-bottom: 27px;
    border-bottom: 1px solid #E2E6E7;
  }

  .house_address_icon {
    width: 18px;
    margin-right: 10px;
  }

  .property_info_txt {
    font-size: 14px;
    font-weight: 400;
    color: #222325;
    line-height: 22px;
  }

  .sort_title {
    font-size: 16px;
    font-weight: bold;
    color: #222325;
    line-height: 22px;
    margin-bottom: 16px;
  }

  .sort_content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 20px;
  }

  .sort_item {
    width: 101px;
    height: 32px;
    font-size: 13px;
    font-weight: 400;
    color: #222325;
    line-height: 34px;
    text-align: center;
    background: #FFFFFF;
    border-radius: 2px;
    border: 1px solid #E2E6E7;
    margin-bottom: 12px;
  }

  .sort_item_active {
    width: 103px;
    height: 34px;
    background: #26C165;
    border-radius: 2px;
    font-size: 13px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 34px;
    text-align: center;
    margin-bottom: 12px;
  }

  .sort_textbox {
    width: 336px;
    height: 160px;
    background: #F8F8F8;
    border-radius: 2px;
    border: 1px solid #E2E6E7;
    padding: 14px 16px;
    margin-bottom: 16px;
  }

  .sort_textbox_placeholder {
    font-size: 13px;
    font-weight: 400;
    color: #B3B9BF;
    line-height: 18px;
  }

  .sort_textbox_txt {
    font-size: 13px;
    font-weight: 400;
    color: #222325;
    line-height: 18px;
  }

  .upload {
    width: 80px;
    height: 80px;
    background: #FAFAFA;
    border-radius: 4px;
    border: 1px solid #EAEAEA;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
  }

  .upload_add {
    font-size: 16px;
    color: #181F2C;
    font-weight: bold;
  }

  .propertyIndexTab2 {
    width: 80px;
    height: 80px;
    margin-bottom: 20px;
  }

  .btn {
    height: 48px;
    text-align: center;
    line-height: 48px;
    background-color: #26C165;
    border-radius: 10px;
    font-size: 15px;
    font-weight: 500;
    color: #FFFFFF;
    margin-bottom: 42px;
  }
</style>